export function isAvailableEnvToBypassApiGateway({ venomEnv, edmundsEnv }) {
  return ['dev', 'sandbox'].includes(venomEnv) || ['qa-21'].includes(edmundsEnv);
}
